import { render, staticRenderFns } from "./ComprasDiretasEncerradas.vue?vue&type=template&id=835fb7a4&scoped=true"
import script from "./ComprasDiretasEncerradas.vue?vue&type=script&lang=js"
export * from "./ComprasDiretasEncerradas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835fb7a4",
  null
  
)

export default component.exports